/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Image, Select } from "antd";
import { useState } from "react";
import { useAppSelector } from "../../../../../../config/hooks";
import { CrossIcon } from "../../../../../../atoms/CustomIcons";

interface PropsType {
  serviceGroupId: string;
  selectSubservicesFunc?: (e: string) => void;
  setSelectedServiceIds?: React.Dispatch<React.SetStateAction<string[]>>;
}

export default function AddSubService(props: PropsType) {
  const { serviceGroupId, setSelectedServiceIds, selectSubservicesFunc } =
    props;
  const [open, setOpen] = useState(false);
  const [selectedService, setSelectedService] = useState<string | null>(null);
  const estimateFormData = useAppSelector(
    (state) => state?.potentialDeal?.estimateFormData
  );

  return (
    <div className="subservice_header" onClick={(e) => e.stopPropagation()}>
      {/* button that opens the select-like overlay */}
      {!open && (
        <>
          <span>Subservice</span>
          <Button
            type="text"
            className="only_icon open-select-trigger"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
            }}
            icon={
              <Image
                src="/images/potential-deals/plus-icon.svg"
                preview={false}
              />
            }
          />
        </>
      )}

      {/* overlay that visually covers the title + button area */}
      {open && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #EFF2F3",
            boxShadow: "0px 4px 16px 0px #1517180A",
            padding: "5px 6px",
            display: "flex",
            gap: 8,
            alignItems: "center",
            borderRadius: 12,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ flex: 1, position: "relative" }}>
            <Select
              placeholder="Search subservice"
              style={{
                width: "100%",
              }}
              suffixIcon={null}
              showSearch
              value={selectedService}
              options={estimateFormData?.services
                ?.filter((options) => options?.parent_id === serviceGroupId)
                .map((service: any) => ({
                  label: service?.name,
                  value: service?.id,
                }))}
              onChange={(value) => {
                setSelectedServiceIds &&
                  setSelectedServiceIds((prevSelected) => [
                    ...new Set([...prevSelected, value]),
                  ]);

                selectSubservicesFunc && selectSubservicesFunc(value);
                setSelectedService(null);
              }}
              onClick={(e) => e.stopPropagation()}
            />
            <Button
              type="text"
              className="only_icon"
              style={{
                position: "absolute",
                right: "10px",
                top: "10px",
                zIndex: 9,
              }}
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
              }}
              icon={<CrossIcon />}
            />
          </div>
        </div>
      )}
    </div>
  );
}
